import { axiosGet, axiosGetblob } from '../axios/httpRequest';

/**
 * 后台查询入住记录分页
 */
export const getCheckInChangeListApi = params => {
    return axiosGet('api/check_in_change/v1/check_in_change', params);
};

/**
 * 时间统计
 */
export const getStatics = params => {
    return axiosGet('/api/check_in_change/statics', params);
};

export const getDownloadApi = params => {
    return axiosGetblob('api/check_in_change/v1/download', params);
};
